"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MenuUtil = {
  getScheduleCategories: function getScheduleCategories() {
    var scheduleCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var categories = arguments.length > 1 ? arguments[1] : undefined;
    return MenuUtil.getLinkedEntities(scheduleCategories, categories);
  },
  getCategoryItems: function getCategoryItems(categoryItems, items) {
    return MenuUtil.getLinkedEntities(categoryItems, items);
  },
  getItemModifierSets: function getItemModifierSets(itemModifierSets, modifierSets) {
    return MenuUtil.getLinkedEntities(itemModifierSets, modifierSets);
  },
  getModifierSetModifiers: function getModifierSetModifiers(modifierSetModifiers, modifiers) {
    return MenuUtil.getLinkedEntities(modifierSetModifiers, modifiers);
  },
  getScheduleById: function getScheduleById(schedules, scheduleId) {
    return schedules.filter(function (_ref) {
      var id = _ref.id;
      return scheduleId === id;
    })[0];
  },
  getCategoryById: function getCategoryById(categories, category) {
    return categories.filter(function (_ref2) {
      var id = _ref2.id;
      return category === id;
    })[0];
  },
  getItemById: function getItemById(items, itemId) {
    return items.filter(function (_ref3) {
      var id = _ref3.id;
      return itemId === id;
    })[0];
  },
  getModifierSetById: function getModifierSetById(modifierSets, modifierSetId) {
    return modifierSets.filter(function (_ref4) {
      var id = _ref4.id;
      return modifierSetId === id;
    })[0];
  },
  getMenuItemVariations: function getMenuItemVariations(item) {
    var variations = item.variations;
    return variations;
  },
  menuItemHasOneVariation: function menuItemHasOneVariation(item) {
    var variations = MenuUtil.getMenuItemVariations(item);
    return variations.length === 1;
  },
  getLinkedEntities: function getLinkedEntities(entityIds, entitiesToLink) {
    return entitiesToLink.filter(function (_ref5) {
      var id = _ref5.id;
      return entityIds.includes(id);
    });
  }
};
var _default = MenuUtil;
exports["default"] = _default;